<template>
    <div>
        <el-tabs name="activeName2" v-model="activeName2" @tab-click="handleClick">
            <el-tab-pane label="订单详情" name="first"></el-tab-pane>
            <el-tab-pane v-if="!contractClosed" label="配货信息" name="second"></el-tab-pane>
            <el-tab-pane v-if="!contractClosed" label="收货单" name="third"></el-tab-pane>
            <el-tab-pane v-if="!contractClosed" label="订单操作记录" name="fourth"></el-tab-pane>
        </el-tabs>
        <swb-goods-order-info name="result_table" :goodsOrderId="goodsOrderId" v-if="showFirst" :theTableHeight="theTableHeight"></swb-goods-order-info>
        <!--使用页面的动态计算，只有第一个页签可以，后面无法计算-->
        <swb-order-goods-alloc-item-list name="result_table" :theTableHeight="theTableHeight" :selfPath="selfPath" :goodsOrderId="goodsOrderId" :manualAllocFlag="manualAllocFlag" v-if="showSecond"></swb-order-goods-alloc-item-list>
        <swb-goods-recv-voucher-list name="result_table" :theTableHeight="theTableHeight" :goodsOrderId="goodsOrderId" v-if="showThird"></swb-goods-recv-voucher-list>
        <swb-goods-order-record-list name="result_table" :theTableHeight="theTableHeight" :goodsOrderId="goodsOrderId" v-if="showFourth"></swb-goods-order-record-list>
    </div>
</template>

<script>

    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { syncSetBreadcrumb } from '../index'
    //
    import SwbGoodsOrderInfo from './GoodsOrderInfo';
    Vue.regist(SwbGoodsOrderInfo);
    //
    import SwbOrderGoodsAllocItemList from './OrderGoodsAllocItemList';
    Vue.regist(SwbOrderGoodsAllocItemList);
    //
    import SwbGoodsRecvVoucherList from './GoodsRecvVoucherList';
    Vue.regist(SwbGoodsRecvVoucherList);

    //
    import SwbGoodsOrderRecordList from './GoodsOrderRecordList';
    Vue.regist(SwbGoodsOrderRecordList);

    export default {
        name: 'swb-show-goods-order',
        path: '/goods/order/detail',
        pathOld: '/to/show/goods/order',
        avlActions: 'allocation_of_cargo|view|cut_down',
        avlScopes: 'retailer',
        notAsResc: false,
        customBreadcrumb: true,
        authen: false,
        desc: '商品订单详情',
        data: function () {
            return {
                theTableHeight: 300,
                activeName2: 'first',
                goodsOrderId: null,
                contractClosed: false,
                manualAllocFlag: null,
                selfPath: Vue.$getClassInfo(this).path,
                showFirst: true,
                showSecond: false,
                showThird: false,
                showFourth: false
            };
        },
        created: function () {
            //
            let routeQuery = this.$getRouteQuery();
            let parentPath = routeQuery.parentPath || null;
            if(parentPath != null) {
                syncSetBreadcrumb("商品订单详情", parentPath);
            }
            this.goodsOrderId = routeQuery.goodsOrderId || null;
            this.manualAllocFlag = Utils.isTrue(routeQuery.manualAllocFlag);
            //
            let contractClosed = routeQuery.contractClosed || false;
            if(contractClosed != null) {
                this.contractClosed = contractClosed == 'true' ? true : contractClosed;
                this.contractClosed = contractClosed == 'false' ? false : contractClosed;
            }
            //
            let activeName = routeQuery.activeName || null;
            if(!Utils.isNoB(activeName)) {
                this.activeName2 = activeName;
                this.handleClick();
            }
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="activeName2"]'));
            domSizeWatcher.start(500);
            //
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            // 页签切换
            handleClick: function () {
                this.showFirst = false;
                this.showSecond = false;
                this.showThird = false;
                this.showFourth = false;
                //
                if(this.activeName2 === "first") {
                    this.showFirst = true;
                } else if(this.activeName2 === "second") {
                    this.showSecond = true;
                } else if(this.activeName2 === "third") {
                    this.showThird = true;
                } else if(this.activeName2 === "fourth") {
                    this.showFourth = true;
                }
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/compo/order/ShowGoodsOrder.vue